// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".responseMain[data-v-4048ef12]{width:80%;max-width:500px;margin:0 auto;padding-top:10%}.showChange[data-v-4048ef12]{border:1px solid #dee2e6;padding:40px 20px;border-radius:5px}", ""]);
// Exports
module.exports = exports;
